import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export const Revelation = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-20%'
  });
  const [flashDone, setFlashDone] = useState(false);
  useEffect(() => {
    if (isInView) {
      setTimeout(() => setFlashDone(true), 300);
    }
  }, [isInView]);
  return <section id="revelation" ref={ref} className="relative py-40 bg-white text-black overflow-hidden" data-id="element-161">
      {/* Flash effect */}
      {isInView && !flashDone && <motion.div className="absolute inset-0 bg-white z-50" initial={{
      opacity: 1
    }} animate={{
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} data-id="element-162" />}

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-163">
        <div className="flex flex-col items-center text-center" data-id="element-164">
          <motion.h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold mb-4 overflow-hidden" initial={{
          clipPath: 'inset(0 100% 0 0)'
        }} whileInView={{
          clipPath: 'inset(0 0% 0 0)'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.5,
          ease: 'easeInOut'
        }} data-id="element-165">
            Instagram te da seguidores.
          </motion.h2>

          <motion.h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-[#D4AF37] mb-16 overflow-hidden" initial={{
          clipPath: 'inset(0 100% 0 0)'
        }} whileInView={{
          clipPath: 'inset(0 0% 0 0)'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 1.2,
          ease: 'easeInOut'
        }} data-id="element-166">
            Una página web te da clientes.
          </motion.h2>

          <motion.div className="w-full h-px bg-gray-300 mb-16" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          delay: 2
        }} data-id="element-167" />

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-12 text-2xl md:text-3xl font-medium" data-id="element-168">
            <motion.span className="text-gray-400" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 2.5
          }} data-id="element-169">
              Instagram es un alquiler.
            </motion.span>
            <motion.span className="text-black font-bold font-serif" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 3
          }} data-id="element-170">
              Tu página web es tu propiedad.
            </motion.span>
          </div>
        </div>
      </div>
    </section>;
};